import React from 'react';
import PropTypes from 'prop-types';
import { Text, TouchableOpacity } from 'react-native-web';

import './Selector.module.scss';

function Selector({
  selected,
  onPress,
  text,
  testID,
}) {
  const containerStyles = `selector ${selected ? 'selectedButton' : ''}`;
  const textStyles = `selectorText ${selected ? 'selectedText' : ''} ${text.length > 16 ? 'longText' : ''}`;
  return (
    <TouchableOpacity styleName={containerStyles} onPress={onPress}>
      <Text data-testid={testID} styleName={textStyles}>{text}</Text>
    </TouchableOpacity>
  );
}

Selector.propTypes = {
  selected: PropTypes.bool,
  onPress: PropTypes.func,
  text: PropTypes.string.isRequired,
  testID: PropTypes.string,
};

Selector.defaultProps = {
  selected: false,
  onPress: () => {},
  testID: null,
};

export default Selector;
